import PageFallback from './PageFallback';

export default PageFallback;
